var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneReactions = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 107 107",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 107,
  height: 107,
  rx: 53.5,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.408 29.631v-8.418a2.413 2.413 0 0 0-2.404-2.404h-36.1a2.413 2.413 0 0 0-2.404 2.404v24.064M75.408 63.326v25.27A2.413 2.413 0 0 1 73.004 91h-36.1a2.413 2.413 0 0 1-2.404-2.404v-7.22M75.406 27.227h-40.64M75.411 84.986h-40.77",
  stroke: "#5C6471",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.363 23.133h-4.816",
  stroke: "#A4ABB7",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.491 32.642H65.767c-2.462 0-4.462 2-4.462 4.462v13.84c0 2.462 2 4.462 4.462 4.462h2.938c.592 0 1.163.238 1.574.65l3.624 3.624a2.227 2.227 0 0 0 3.155 0l3.625-3.624a2.23 2.23 0 0 1 1.574-.65h3.22c2.462 0 4.462-2 4.462-4.462v-13.84c0-2.462-2-4.462-4.462-4.462h.014Z",
  stroke: "#F15B35",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M82.476 45.053c.996-1.747.505-4.043-1.133-5.206a4.133 4.133 0 0 0-2.412-.765 4.148 4.148 0 0 0-3.48 1.877 4.148 4.148 0 0 0-3.48-1.877c-.513 0-1.003.094-1.451.26-2.375.888-3.242 3.84-1.885 5.985a.26.26 0 0 0 .051.072 9.52 9.52 0 0 0 1.978 2.05l4.852 3.755 4.83-3.754c.845-.657 1.581-1.451 2.123-2.376v-.014l.007-.007ZM44.812 49.37H25.087c-2.462 0-4.462 2-4.462 4.462v13.84c0 2.463 2 4.463 4.462 4.463h2.938c.592 0 1.163.238 1.574.65l3.625 3.624a2.227 2.227 0 0 0 3.155 0l3.624-3.625a2.23 2.23 0 0 1 1.574-.65h3.22c2.462 0 4.462-2 4.462-4.461v-13.84c0-2.463-2-4.463-4.462-4.463h.015Z",
  stroke: "#F15B35",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.95 69.355a7.747 7.747 0 1 0 0-15.494 7.747 7.747 0 0 0 0 15.494Z",
  stroke: "#F15B35",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.448 62.575h-8.996a.328.328 0 0 0-.325.361c.231 1.971 2.303 3.51 4.823 3.51 2.52 0 4.592-1.538 4.823-3.51a.324.324 0 0 0-.325-.36ZM33.333 59.348a.968.968 0 0 0-1.935 0M38.505 59.348a.968.968 0 0 0-1.935 0",
  stroke: "#F15B35",
  strokeWidth: 1.444,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.313 76.257v2.462M23.313 86.278v2.462M29.564 82.502h-2.462M19.54 82.502h-2.47M26.49 79.325l-1.256 1.257M21.398 84.423l-1.25 1.249M26.49 85.672l-1.256-1.25M21.398 80.582l-1.25-1.257",
  stroke: "#A4ABB7",
  strokeWidth: 1.083,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.316 83.412a.91.91 0 1 0 0-1.82.91.91 0 0 0 0 1.82Z",
  fill: "#A4ABB7"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M84.5 16v2.007M84.5 24.173v2.014M89.585 21.09h-2.007M81.413 21.09h-2.007M87.088 18.505l-1.025 1.018M82.932 22.657l-1.018 1.025M87.088 23.682l-1.025-1.025M82.932 19.523l-1.018-1.018",
  stroke: "#A4ABB7",
  strokeWidth: 1.083,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M84.494 21.834a.744.744 0 1 0 0-1.487.744.744 0 0 0 0 1.487Z",
  fill: "#A4ABB7"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M83.36 64.467a2.18 2.18 0 1 0 0-4.36 2.18 2.18 0 0 0 0 4.36ZM40.962 45.096a2.18 2.18 0 1 0 0-4.36 2.18 2.18 0 0 0 0 4.36Z",
  stroke: "#A4ABB7",
  strokeWidth: 1.083,
  strokeMiterlimit: 10
})));
export default SvgPhoneReactions;